// extracted by css-extract-rspack-plugin
export default {"orgLink":"OrgLink-module__orgLink__Wd41sZI"};